import { UPDATE_MEDICAL_PLAN } from "./Actions";

export function newDependentPlans(state = [], action) {
  switch (action.type) {
    case UPDATE_MEDICAL_PLAN:
      return action.newDependentPlans;

    default:
      return state;
  }
}
export function newDependentCost(state = null, action) {
  switch (action.type) {
    case UPDATE_MEDICAL_PLAN:
      return action.newDependentCost;

    default:
      return state;
  }
}
